import styled from 'styled-components'

import { Layout, PrimaryButton, TextDetail } from "../components/index";
import { useDispatch, useSelector } from "react-redux";
import { push } from "connected-react-router"
import Button from '@material-ui/core/Button'
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';

import { useEffect, useState } from 'react';
import { db, FirebaseTimestamp } from '../firebase';
import { TextField } from '@material-ui/core';

const dateTimeToString = (date) => {
    return date.getFullYear() + '-' + 
        ('00' + (date.getMonth()+1)).slice(-2) + '-' + 
        ('00' + date.getDate()).slice(-2) + ' ' + 
        ('00' + date.getHours()).slice(-2) + ':' + 
        ('00' + date.getMinutes()).slice(-2) + ':' + 
        ('00' + date.getSeconds()).slice(-2)
}

const ContactDetail = () => {
    const dispatch = useDispatch()

    // URLからcontactIdを取得
    const selector = useSelector(state=>state)
    const path = selector.router.location.pathname
    const contactId = path.split('/contact/dp/')[1]

    const [isOpen] = useState(false)
    const [isReply, setIsReply] = useState(false)
    const [date, setDate] = useState('')
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [tel, setTel] = useState('')
    const [matter, setMatter] = useState('')
    const [inquery, setInquery] = useState('')
    const [update, setUpdate] = useState(false)
    const [reply, setReply] = useState('')
    const [replies, setReplies] = useState([])

    // 返信時
    const replyToContact = (reply) => {
        // Validation
        if (reply === '' ) {
            alert('返信内容が空白になっています')
            return false
        }
        if (window.confirm("送信します。よろしいですか？")) {
            // メール送信
            // Firestore更新
            const timestamp = FirebaseTimestamp.now()
            const newReplyId = db.collection('contacts').doc(contactId)
                                 .collection('replies').doc().id
            const data = {
                id: newReplyId,
                reply,
                created_at: timestamp
            }
            db.collection('contacts').doc(contactId)
              .collection('replies').doc(newReplyId)
              .set(data)
              .then(()=>{
                  db.collection('contacts').doc(contactId)
                    .set({isReply:true},{merge:true})
                    .then(()=>{
                        // 完了メッセージ表示・画面更新・フォームリセット・返信済みに
                        alert('まだメールはまだ送信できませんが、DBには返信内容を保存しました。')
                        setUpdate(!update)
                        setReply('')
                        return;
                    })
              })
        } else {
            return false;
        }
    }

    
    
    // 未読にする
    const markAsUnead = () => {
        // Firestoreを更新
        db.collection('contacts').doc(contactId)
          .set({isOpen: false},{merge: true})
          .then(()=>dispatch(push('/admin/contact')))
    }

    useEffect(() => {
        if(contactId) {
            db.collection('contacts').doc(contactId).get()
            .then(doc => {
                const data = doc.data()
                setIsReply(data.isReply)
                setDate(data.created_at)
                setName(data.name)
                setEmail(data.email)
                setTel(data.tel)
                setMatter(data.matter)
                setInquery(data.inquery)
            })
            .then(()=>{
                    db.collection('contacts').doc(contactId)
                      .collection('replies').orderBy('created_at','asc').get()
                      .then(snapshots => {
                            const tempReplyList = []
                            snapshots.forEach(snapshot => {
                                tempReplyList.push(snapshot.data())
                            })
                            setReplies(tempReplyList)
                      })
            })
        }
    },[contactId, update])

    // 既読にする
    useEffect(() => {
        // Firestoreを更新
        if(contactId) {
            db.collection('contacts').doc(contactId)
              .set({isOpen: true},{merge: true})
              .then(() => console.log(isOpen))
        }
    }, [contactId, isOpen])

    return (
        <Layout>
            <div className='spacer-50' />
            <h1 style={{textAlign:'center'}}>お問い合わせ詳細</h1>

            <div className='spacer-50' />
            <Wrapper>

                <TextDetail label={'お問い合わせ日時'} value={date ? dateTimeToString(date.toDate()) : ""} />
                <TextDetail label={'お名前'} value={name} />
                <TextDetail label={'メールアドレス'} value={email} />
                <TextDetail label={'電話番号'} value={tel} />
                <TextDetail label={'お問い合わせの種類'} value={matter} />

                <div className='spacer-50' />
                <SubHeading>お問い合わせ内容</SubHeading>
                <p>{inquery}</p>

                <div className='spacer-50' />
                <SubHeading>返信履歴（{replies.length}）</SubHeading>
                { isReply ? (
                    replies.map(reply=>(
                        <Accordion key={reply.id}>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} >
                            <Typography>{reply.created_at ? dateTimeToString(reply.created_at.toDate()) : ""}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                            <Typography>
                                {reply.reply}
                            </Typography>
                            </AccordionDetails>
                        </Accordion>
                    ))
                ):(
                    <span>まだ返信していません</span>
                )}
            
                <div className='spacer-50' />
                <SubHeading>返信フォーム</SubHeading>
                <TextField 
                    type={'text'} fullWidth={true} multiline={true} rows={10} label={'返信内容を記載'} required={true}
                    value={reply} onChange={e=>setReply(e.target.value)}
                />
                <div className='spacer-50' />

            </Wrapper>

            <div style={{textAlign:'center'}}>
                <PrimaryButton label="送信する" operation={() => replyToContact(reply)} />
                <div className='spacer-50' />
                <Button onClick={()=>dispatch(push('/admin/contact'))}>一覧に戻る</Button>
                <Button onClick={markAsUnead}>未読にして一覧に戻る</Button>
            </div>

            <div className='spacer-100' />
        </Layout>
    );
};

export default ContactDetail

const Wrapper = styled.div`
    width: 480px;
    margin: 0 auto;
`
const SubHeading = styled.h4`
    font-size: 24px !important;
    margin-bottom: 24px;
`